// Resolves which home the root landing should send the user to, given the
// candidates that might name it, the set of ids the signed-in user actually owns,
// and a fallback.
//
// SECURITY: the stored "last selected home" preference lives in localStorage and
// is NOT scoped to a user, so on a shared browser it can name a home that belongs
// to a different account. Every candidate is therefore validated against the ids
// the current session was seeded with before it is trusted; anything unrecognised
// is dropped and we fall back to the account's default home. (StoreBootstrap also
// clears the preference on sign-out — this is the belt-and-braces second check.)
//
// candidates: ordered ids to try, most-specific first (e.g. the in-session choice,
//   then the persisted preference). Falsy entries are ignored.
// validIds:   the ids of the homes the current user owns this session.
// fallbackId: the id to use when no candidate is valid (e.g. the default home);
//   returned as-is, so pass an already-valid id or null.
export function resolveSelectedHomeId(candidates, validIds, fallbackId) {
  for (const candidate of candidates) {
    if (candidate && validIds.includes(candidate)) {
      return candidate;
    }
  }
  return fallbackId ?? null;
}
